import type { ButtonVariantProps } from "./button-variants";

import { Slot } from "@radix-ui/react-slot";
import * as React from "react";
import { cn } from "../utils/classnames";
import { buttonVariants } from "./button-variants";

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    ButtonVariantProps {
  asChild?: boolean;
  loading?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { className, variant, size, asChild = false, loading = false, ...props },
    ref,
  ) => {
    const Comp = asChild ? Slot : "button";

    return (
      <Comp
        className={cn(buttonVariants({ className, loading, size, variant }))}
        ref={ref}
        {...props}
      ></Comp>
    );
  },
);
Button.displayName = "Button";

export { Button, type ButtonProps, type ButtonVariantProps, buttonVariants };
